class MenuHeader {
  constructor(el) {
    this.el = el;
    this.headerHeight = document.querySelector('[data-header-menu]');
    this.anchorMenuHeight = document.querySelector('[data-anchor-menu]');
    this.imagesLoaded = false;
    this.init();
  }

  init() {
    if (!this.el) {
      return;
    }
    this.elMenuItems = this.el.querySelectorAll(
      '[data-dropdown-menu-header-item]'
    );
    this.elSubmenuItemsOlder = this.el.querySelectorAll(
      '[data-dropdown-menu-item-submenu-header] [data-js-li]'
    );
    this.elSubmenuItems = this.el.querySelectorAll(
      '[data-dropdown-menu-item-submenu-header] [data-js-li]:not([data-js-1st-column])'
    );
    this.elSubmenuItems1StColumn = this.el.querySelectorAll(
      '[data-dropdown-menu-item-submenu-header] [data-js-1st-column]'
    );
    this.level1Li = this.el.querySelectorAll('[data-level="1"] [data-js-li]');
    this.level2Parent = this.el.querySelectorAll(
      '[data-level="2"] [data-level2-container]'
    );
    this.level2Li = this.el.querySelectorAll('[data-level="2"] [data-js-li]');
    this.level3Children = this.el.querySelectorAll(
      '[data-level="3"] [data-level-3-child]'
    );
    this.onLoad();
    Array.from(this.elMenuItems).forEach((elMenuItem) => {
      elMenuItem.addEventListener('click', () => {
        this.handleToggleMenu(elMenuItem);
      });
    });

    Array.from(this.elSubmenuItems1StColumn).forEach((elSubmenuItem) => {
      elSubmenuItem.addEventListener('click', (e) => {
        e.stopPropagation();
        this.handleToggleSubmenu(elSubmenuItem);
      });
    });

    Array.from(this.elSubmenuItems).forEach((elSubmenuItem) => {
      elSubmenuItem.addEventListener('mouseover', () => {
        this.hoverTimeout = setTimeout(() => {
          this.handleToggleSubmenu(elSubmenuItem);
        }, 200);
      });
      elSubmenuItem.addEventListener('mouseleave', () => {
        clearTimeout(this.hoverTimeout);
      });
    });

    this.handleOutsideClick();
  }

  handleToggleMenu(elMenuItem) {
    if (!this.imagesLoaded) {
      this.el.querySelectorAll('img').forEach((img) => {
        if (img.dataset.menuSrc) {
          img.setAttribute('src', img.dataset.menuSrc);
        }
      });
      this.imagesLoaded = true;
    }

    this.elMenuItems.forEach((item) => {
      if (item !== elMenuItem) {
        item.classList.remove('active');
      }
    });
    this.resetMenuState(elMenuItem);
    elMenuItem.classList.toggle('active');
  }

  handleToggleSubmenu(elMenuItem) {
    const currentParent = elMenuItem.closest('[data-level]');
    const currentRel = elMenuItem.dataset.rel;
    const currentDataName = elMenuItem.dataset.name;

    // only while hovering first item
    const level2Items = elMenuItem
      .closest('[data-menu-header-items-container]')
      .querySelectorAll('[data-level="2"] [data-js-li]');

    // only while hovering first item
    const level2ParentItems = elMenuItem
      .closest('[data-menu-header-items-container]')
      .querySelectorAll('[data-level="2"] [data-level2-container]');

    const level3Children = elMenuItem
      .closest('[data-menu-header-items-container]')
      .querySelectorAll('[data-level="3"] [data-level-3-child]');

    // 3rd menu active/non active
    if (level3Children.length > 0) {
      level3Children.forEach((element) => {
        const rels = element.dataset.rel;
        const getFirstParent = rels.split('/')[0];
        const getsecondParent = rels.split('/')[1];
        const parentPath = `${getFirstParent}/${getsecondParent}`;
        element.classList.remove('active');

        // set element active while level 1 element is active
        if (parentPath === currentRel) {
          // set first item active while hovering top parent
          const parentLevel1 = document.querySelector(
            `[data-parent-level-1="${currentRel}"]`
          );
          parentLevel1.classList.add('active');
        }

        // set element active while level 2 element is active
        if (currentDataName === rels) {
          element.classList.add('active');
        }
      });
    }

    // set all active rels
    if (currentRel) {
      const getAllCurrentRel = document.querySelectorAll(
        `[data-rel="${currentRel}"]`
      );

      // remove active elements
      if (level2Items.length > 0) {
        level2Items.forEach((element) => {
          element.classList.remove('active');
        });
      }

      // add active to hovered item 2nd level li element
      const getFirstCurrentRel = document.querySelector(
        `[data-rel="${currentRel}"][data-level2-container] [data-js-li]`
      );

      if (getFirstCurrentRel) {
        getFirstCurrentRel.classList.add('active');
      }

      if (level2ParentItems.length > 0) {
        level2ParentItems.forEach((element) => {
          element.classList.remove('active');
          // element.querySelector('li').classList.add('active');
        });
      }

      getAllCurrentRel.forEach((element) => {
        element.classList.add('active');
      });
    }

    // remove all active elements
    if (currentParent) {
      const elLiChildren = currentParent.querySelectorAll('[data-js-li]');
      if (elLiChildren) {
        elLiChildren.forEach((element) => {
          element.classList.remove('active');
        });
      }
    }

    // add current element hovered to active
    elMenuItem.classList.toggle('active');
  }

  onLoad() {
    const hash = window.location.hash;
    if (!hash) {
      return;
    }
    const id = document.querySelector(hash);

    if (!id) {
      return;
    }

    const offsetTop = document.querySelector(hash).offsetTop;
    const offsetPosition = this.anchorMenuHeight
      ? offsetTop -
        this.headerHeight.offsetHeight +
        this.anchorMenuHeight.offsetHeight
      : offsetTop - this.headerHeight.offsetHeight;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
      duration: 500,
    });
  }

  handleOutsideClick() {
    document.addEventListener('click', (event) => {
      if (!this.el.contains(event.target)) {
        this.elMenuItems.forEach((item) => {
          item.classList.remove('active');
        });
      }
    });
  }

  resetMenuState(elMenuItem) {
    const level1Items = elMenuItem.querySelectorAll(
      '[data-level="1"] [data-js-li]'
    );
    const level2Parents = elMenuItem.querySelectorAll(
      '[data-level="2"] [data-level2-container]'
    );
    const level2Items = elMenuItem.querySelectorAll(
      '[data-level="2"] [data-js-li]'
    );
    const level3Children = elMenuItem.querySelectorAll(
      '[data-level="3"] [data-level-3-child]'
    );
    level1Items.forEach((element) => {
      element.classList.remove('active');
    });
    level2Items.forEach((element) => {
      element.classList.remove('active');
    });
    level2Parents.forEach((element) => {
      element.classList.remove('active');
    });
    level3Children.forEach((element) => {
      element.classList.remove('active');
    });

    // set first item of all submenu to active on mouseleave
    if (level1Items.length > 0) {
      level1Items[0].classList.add('active');
    }
    if (level2Items.length > 0) {
      level2Items[0].classList.add('active');
    }
    if (level2Parents.length > 0) {
      level2Parents[0].classList.add('active');
    }
    if (level3Children.length > 0) {
      level3Children[0].classList.add('active');
    }
  }
}

export default MenuHeader;
